/**
 * Wind Layer Store
 * Exposes wind data state from the WebGL layer to React UI components
 */
import { create } from 'zustand';

interface WindState {
  /** Current data source name (e.g., 'GFS Global', 'HRRR 3km') */
  sourceName: string;
  /** Maximum wind speed in current dataset (m/s) */
  maxSpeed: number;
  /** Timestamp when wind data was last fetched */
  lastFetchedAt: number;
  /** Whether wind data is currently loaded */
  hasData: boolean;
  /** GPU tier detected */
  gpuTier: string;
}

interface WindStore extends WindState {
  /** Update wind state from the WebGL layer */
  setWindState: (state: Partial<WindState>) => void;
}

export const useWindStore = create<WindStore>((set) => ({
  sourceName: '',
  maxSpeed: 30,
  lastFetchedAt: 0,
  hasData: false,
  gpuTier: 'medium',

  setWindState: (partial) => set((state) => ({ ...state, ...partial })),
}));
